import React from 'react';
import { Alert } from '@instructure/ui-alerts';
import { Link } from '@instructure/ui-link';
import { Text } from '@instructure/ui-text';



export const SubmitErrorAlert = ({ dispatch, err }) => {
  return (
    <Alert variant="error"
           margin="small"
           renderCloseButtonLabel="Close"
           onDismiss={ () => dispatch(dismissErrorAction()) } >

      {messageForError(err)}

    </Alert>
  );
};



const messageForError = err => {
  if (err.type === 'SUBMISSION_ERROR_TEST_ID_EXPIRED') {
    return 'The test ID has expired or changed. Your answers cannot be submitted. Please write down your answers and ask your teacher for help.';

  } else if (err.type === 'SUBMISSION_ERROR_INVALID') {
    return 'There was a problem submitting your assessment. Please reload the page and try submitting again.';

  } else if (err.type === 'SUBMISSION_ERROR_NO_RESPONSES') {
    const reload = err.error?.reload
    if (reload) {
      return (
        <Text>
          There was a problem submitting your assessment.
          Please <Link onClick={() => doReload(reload)}>reload</Link> the assessment and try submitting again.
        </Text>
      )
    } else {
      return 'There was a problem submitting your assessment. Please try submitting again.'
    }

  } else {
    return 'There was a problem connecting to the servers to submit your answers. Please check your internet connection and try again.';
  }
};



const dismissErrorAction = () => ({
  type: 'DISMISS_SUBMISSION_ERROR',
  payload: null
});

const doReload = spec => {
  try {
    let location = document.location
    let params = new URLSearchParams(location.search)
    const { customID, testID, validation } = spec

    if (customID)
      params.set('student_id', customID)
    if (testID)
      params.set('test_id', testID)
    if (validation)
      params.set('validation', validation)

    // Perform the redirect:
    location.search = params.toString()

  } catch (e) {
    console.error(e)
  }
}
